import React, {  } from "react";

import {
	PDFReceiverMessages,
	PdfSenderMessages,
	ReceiverTextMessages,
	RecevicerImageMessage,
	SenderImageMessage,
	SenderTextMessages
} from '../../components/chat/messages';

// // const formatDate = (dateString) => {
// 	const messageDate = new Date(dateString);
// 	const currentDate = new Date();
// 	const diffInDays = Math.floor((currentDate - messageDate) / (1000 * 60 * 60 * 24));

// 	if (diffInDays === 0) {
// 		return 'Today';
// 	} else if (diffInDays === 1) {
// 		return 'Yesterday';
// 	} else {
// 		const day = messageDate.getDate();
// 		const monthNames = [
// 			'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
// 			'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
// 		];
// 		const monthIndex = messageDate.getMonth();
// 		const year = messageDate.getFullYear();

// 		return `${day} ${monthNames[monthIndex]}, ${year}`;
// 	}
// };


export const renderMessagesByDate = (allGroupMessages, profileData, value, openOverlay, scrolling, isVisible, chatBodyRef, selectedData) => {



	let user_id = '';

	if (selectedData?.user_id?.length >= 1) {
		user_id = selectedData?.user_id[0]; // If user_id is an array
	} else if (selectedData?.id) {
		user_id = selectedData?.id; // If user_id is a single ID
	}

	return <>

		{allGroupMessages && Object?.keys(allGroupMessages)?.sort((a, b) => new Date(a) - new Date(b))?.map((formattedDate, dateIndex) => (
			<React.Fragment key={dateIndex}>

				<div className={scrolling && isVisible ? 'rubik-400 text-center fs-12 visible' : 'hidden'}>{formattedDate}</div>

				{allGroupMessages[formattedDate]?.sort((a, b) => a.id - b.id)?.map((message, messageIndex) => (
					<React.Fragment key={messageIndex}>

						{message?.user_id !== user_id && (
							<>
								{message.message_text && (
									<SenderTextMessages
										profileData={profileData}
										textMessage={message.message_text}
										time={message.date_and_time?.slice(12)}
									/>
								)}

								{message?.message_media?.length > 0 && (
									<>
										{message?.message_media?.map((responseImage, imgIndex) => (
											<SenderImageMessage
												key={imgIndex}
												profileData={profileData}
												image={responseImage}
												openOverlay={openOverlay}
												time={message.date_and_time?.slice(12)}
											/>
										))}
									</>
								)}

								{/* Render PDF message if exists */}
								{message?.media_pdf?.length > 0 && (
									<>
										{message?.media_pdf?.map((pdf, pdfIndex) => (
											<PdfSenderMessages
												key={pdfIndex}
												profileData={profileData}
												pdf={pdf}
												time={message.date_and_time?.slice(12)}
											/>
										))}
									</>
								)}
							</>
						)}

						{/* Check if the message is sent by the selected user */}
						{message?.user_id === user_id && (
							<>
								{/* Render text message */}
								{message.message_text && (
									<ReceiverTextMessages
										chatUser={value}
										textMessage={message.message_text}
										time={message.date_and_time?.slice(12)}
										data={message}
										selectedData={selectedData}
									/>
								)}

								{/* Render image message if exists */}
								{message?.message_media?.length > 0 && (
									<>
										{message?.message_media?.map((resImg, imgIndex) => (
											<RecevicerImageMessage
												key={imgIndex}
												chatUser={value}
												time={message.date_and_time?.slice(12)}
												openOverlay={openOverlay}
												image={resImg}
												data={message}
												selectedData={selectedData}
											/>
										))}
									</>
								)}

								{/* Render PDF message if exists */}
								{message?.media_pdf?.length > 0 && (
									<>
										{message?.media_pdf?.map((pdf, pdfIndex) => (
											<PDFReceiverMessages
												key={pdfIndex}
												chatUser={value}
												pdf={pdf}
												time={message.date_and_time?.slice(12)}
												data={message}
												selectedData={selectedData}
											/>
										))}
									</>
								)}
							</>
						)}
					</React.Fragment>
				))}
			</React.Fragment>
		))}


	</>
};

